import { computed, onMounted, ref } from 'vue';
import { Capacitor } from '@capacitor/core';

export const usePWAInstall = () => {
    const showPwaInstallModal = ref(false);
    let deferredPrompt: any = null;

    // Only show on web platform, not native apps
    const isWebPlatform = !Capacitor.isNativePlatform();

    // Detect iOS device
    const isIOSDevice = () => {
        return /iPad|iPhone|iPod/.test(navigator.userAgent) ||
               (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
    };

    // Detect if the browser is Safari on iOS
    const isSafariOnIOS = () => {
        return isIOSDevice() && navigator.userAgent.includes('Safari') && !navigator.userAgent.includes('CriOS') && !navigator.userAgent.includes('FxiOS');
    };

    // Check if PWA is already installed
    const isPWAInstalled = computed(() => {
        if (!isWebPlatform) return true; // Hide on native apps

        // Check if already installed
        if (window.matchMedia && window.matchMedia('(display-mode: standalone)').matches) {
            return true; // Already installed
        }

        // Check if running in a PWA context (iOS)
        if ((window.navigator as any).standalone) {
            return true; // Already installed (iOS)
        }

        return false;
    });

    const installPWA = async () => {
        if (deferredPrompt) {
            deferredPrompt.prompt();
            await deferredPrompt.userChoice;
            deferredPrompt = null;
        } else {
            showPwaInstallModal.value = true;
        }
    };

    // Listen for beforeinstallprompt event
    onMounted(() => {
        if (isWebPlatform) {
            window.addEventListener('beforeinstallprompt', (e) => {
                e.preventDefault();
                deferredPrompt = e;
            });
        }
    });

    return {
        showPwaInstallModal,
        isPWAInstalled,
        installPWA,
        isWebPlatform,
        isSafariOnIOS,
        isIOSDevice
    };
};
